import { VehicleColorTypeEnum } from '../enums/vehicle-color-type.enum';

/**
 * Create vehicle color DTO
 */
export class CreateVehicleColorDto {
	color?: string;
	name!: string;
	notes?: string;
	type!: VehicleColorTypeEnum;
	externalReference?: string;
}
